<div (click)="this.chipClicked.emit()" class="content">
  <itl-alberta-icon class="icon" *ngIf="icon" [name]="icon"></itl-alberta-icon>
  <div class="text"><ng-content></ng-content></div>
</div>
<div class="dismiss-button" tappable (click)="this.dismissClicked.emit()" *ngIf="showDismiss">
  <itl-alberta-icon name="alberta-cancel"></itl-alberta-icon>
</div>
